import Form from "./form";
import { AttendanceLocal } from "../../../../../../../../../../../../../@types/attendance-local";
import { AttendanceLocalDepartmentGuiche } from "../../../../../../../../../../../../../@types/attendance-local-department-guiche";
import { useAttendanceLocalDepartmentGuicheServiceComplementCreate } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/service/complement/create";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../../../@types/attendance-local-department";

type Props = {
    unidade: AttendanceLocal["slug_unidade"];
    setor_unidade: AttendanceLocalDepartment["id"];
    guiche_id: AttendanceLocalDepartmentGuiche["id"];
    buttonTrigger?: React.ReactNode;
};

export default function FormCreate(props: Props) {
    const mutation = useAttendanceLocalDepartmentGuicheServiceComplementCreate();

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
